import { Link } from "react-router-dom";
import logo from "../assets/images/brand-logo-2.png"

function BrandLogo({ width, height, className = "", ...res }) {
  return (
    <Link to="/" className={className} {...res}>
      <img
        src={logo}
        alt="رومیت"
        width={width}
        height={height}
        className="img-fluid drop-sh-eblue-10"
      />
    </Link>
  );
}

export default BrandLogo;
